module.exports = __webpack_public_path__ + "static/media/sell.a6531ad9.svg";